import React from 'react';
import PropTypes from 'prop-types';
import { StyledAparatVideo } from './AparatVideo.styles';

function AparatVideo({ title, src, ...otherProps }) {
  return (
    <StyledAparatVideo className='aparat-video'>
      <span
        style={{
          display: 'block',
          paddingTop: '57%',
        }}
      ></span>
      <iframe
        title={title}
        src={src}
        allowFullScreen='true'
        webkitallowfullscreen='true'
        mozallowfullscreen='true'
        {...otherProps}
      ></iframe>
    </StyledAparatVideo>
  );
}

AparatVideo.propTypes = {
  title: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
};

export default AparatVideo;
